module.exports = __webpack_public_path__ + "img/PTSans-CaptionBold.7fbc6921.svg";